import {
  GET_ORGANIZATIONS,
  FETCH_ORGANIZATION,
  DELETE_ORGANIZATION,
  ADD_ORGANIZATION,
  EDIT_ORGANIZATION,
  EDIT_ORGANIZATION_LOGO,
  VALIDATE_ORGANIZATION,
  CLEAR_ORGANIZATION,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  organizations: [],
  organization: [],
  organization_logo: [],
  pending: false,
  validation: [],
};

export default function Organization(state = initialState, action) {
  switch (action.type) {
    case GET_ORGANIZATIONS:
      return {
        ...state,
        organizations: action.payload,
        pending: false,
      };

    case FETCH_ORGANIZATION:
      return {
        ...state,
        organization: action.payload,
        [action.payload.id]: action.payload, pending: false
      };

    case EDIT_ORGANIZATION_LOGO:
      const newState = { ...state };
      newState.organization['logo']= action.payload.logo
      return { ...state, 
        organization_logo: action.payload, 
        pending: false };
    case EDIT_ORGANIZATION:
      return { ...state, [action.payload.id]: action.payload, pending: false };
    case VALIDATE_ORGANIZATION:
      return {
        ...state,
        validation: action.payload,
        pending: false,
      };
    case DELETE_ORGANIZATION:
      return {
        ...state,
        organizations: state.organizations.results.filter(
          (row) => row.id !== action.payload
        ),
      };

    case ADD_ORGANIZATION:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };

    case CLEAR_ORGANIZATION:
      return {
        ...state,
        organizations: [],
        validation: [],
      };

    case CLEAR_ALL:
      return {
        ...state,
        organizations: [],
        validation: [],
      };

    default:
      return state;
  }
}
